import { Activity, Brain, Heart } from 'lucide-react'
import { memo, useEffect, useState } from 'react'
import { API_URL, apiFetch } from '../../../config/api'

// ── Metrics Widget ─────────────────────────────────────────────────────────────
export const MetricsWidget = memo(() => {
  const [metrics, setMetrics] = useState({ cpu: 0, mem: 0, req: 0 })

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const res = await apiFetch(`${API_URL}/api/monitoring/dashboard`)
        const data = await res.json()
        setMetrics({ cpu: data.cpu || 0, mem: data.mem || 0, req: data.requests || 0 })
      } catch { setMetrics({ cpu: 0, mem: 0, req: 0 }) }
    }
    fetchMetrics()
    const interval = setInterval(fetchMetrics, 5000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
        <Activity size={12} color="#10b981" />
        <span style={{ fontSize: 10, fontWeight: 700, color: '#10b981', textTransform: 'uppercase' }}>System</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
        <div><div style={{ fontSize: 9, color: 'var(--os-muted)' }}>CPU</div><div style={{ fontSize: 14 }}>{metrics.cpu}%</div></div>
        <div><div style={{ fontSize: 9, color: 'var(--os-muted)' }}>MEM</div><div style={{ fontSize: 14 }}>{metrics.mem}%</div></div>
        <div style={{ gridColumn: 'span 2' }}><div style={{ fontSize: 9, color: 'var(--os-muted)' }}>REQUESTS</div><div style={{ fontSize: 14 }}>{metrics.req}</div></div>
      </div>
    </div>
  )
})

// ── Twin Widget ────────────────────────────────────────────────────────────────
export const TwinWidget = memo(() => {
  const [twin, setTwin] = useState<any>(null)

  useEffect(() => {
    apiFetch(`${API_URL}/api/twin/me`)
      .then(r => r.json())
      .then(d => setTwin(d))
      .catch(() => {})
  }, [])

  return (
    <div style={cardStyle} onClick={() => window.dispatchEvent(new CustomEvent('runai:open-window', { detail: 'twin' }))}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 12 }}>
        <Brain size={12} color="#8b5cf6" />
        <span style={{ fontSize: 10, fontWeight: 700, color: '#8b5cf6', textTransform: 'uppercase' }}>Twin</span>
      </div>
      {!twin ? 'Loading...' : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <div style={{ fontSize: 14, fontWeight: 600 }}>{twin.twin_percent}%</div>
          <div style={{ fontSize: 9, color: 'var(--os-muted)' }}>Stage: {twin.twin_stage}</div>
          <div style={{ fontSize: 9, color: 'var(--os-muted)' }}>Bond: {twin.bond_score}</div>
        </div>
      )}
    </div>
  )
})

// ── Pulse Widget ─────────────────────────────────────────────────────────────
export const PulseWidget = memo(() => {
  const [logs, setLogs] = useState<any[]>([])

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await apiFetch(`${API_URL}/api/pulse/log`)
        const data = await res.json()
        setLogs(Array.isArray(data) ? data.slice(0, 5) : [])
      } catch { setLogs([]) }
    }
    fetchLogs()
    const interval = setInterval(fetchLogs, 30000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div style={cardStyle} onClick={() => window.dispatchEvent(new CustomEvent('runai:open-window', { detail: 'flzhub' }))}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <Heart size={12} color="#ec4899" />
          <span style={{ fontSize: 10, fontWeight: 700, color: '#ec4899', textTransform: 'uppercase' }}>Pulse</span>
        </div>
        <div style={{ fontSize: 10, color: 'var(--os-muted)' }}>{logs.length} Active</div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {logs.length === 0 ? <div style={{ fontSize: 10, color: 'var(--os-muted)' }}>No recent pulse...</div> : logs.map((log: any, i: number) => (
          <div key={i} style={{ fontSize: 9, display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid rgba(255,255,255,0.05)', paddingBottom: 2 }}>
            <span style={{ color: 'var(--os-text)' }}>{log.service}</span>
            <span style={{ color: 'var(--os-muted)' }}>{log.status}</span>
          </div>
        ))}
      </div>
    </div>
  )
})

const cardStyle: React.CSSProperties = {
  background: 'rgba(0,0,0,0.3)',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: '1px solid var(--os-card-border)',
  borderRadius: 16,
  padding: '14px 16px',
  cursor: 'pointer',
  minWidth: 120
}
